import { gql } from "urql"

export default gql`
  mutation ($sourceUserId: ID!, $matchUserId: ID!) {
    matchUser(studentId: $sourceUserId, tutorId: $matchUserId) {
      tutor {
        id
        showPath
        fullName
        lastName
        tutorToStudentPhoneNumber(studentId: $sourceUserId)
        studentToTutorPhoneNumber(studentId: $sourceUserId)
      }
    }
  }
`
